import {
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';

@Component({
  selector: 'app-square-icon-button',
  imports: [
    MatIcon,
    MatButton,
  ],
  templateUrl: './square-icon-button.component.html',
  styleUrl: './square-icon-button.component.scss',
})
export class SquareIconButtonComponent {

  public readonly icon: InputSignal<string> = input<string>('menu');

  public readonly color: InputSignal<string> = input<string>('primary');

  public readonly clicked: OutputEmitterRef<void> = output<void>();

  handleClick(): void {
    this.clicked.emit();
  }

}
